"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./loading-indicator.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var timeToFade = 250;
var timeToSlideToCenter = 500;

/**
 * A general-purpose loading indicator for use during data requests
 * and errors are displayed to users.
 */
var LoadingIndicator = /*#__PURE__*/function (_Component) {
  function LoadingIndicator(props) {
    var _this;
    _classCallCheck(this, LoadingIndicator);
    _this = _callSuper(this, LoadingIndicator, [props]);
    _this.state = {
      failure: props.error,
      working: props.active,
      fast: props.error && !props.active,
      fade: false
    };
    _this.startWorking = _this.startWorking.bind(_this);
    _this.stopWorking = _this.stopWorking.bind(_this);
    _this.stopAfterIteration = _this.stopAfterIteration.bind(_this);
    _this.switchToFailure = _this.switchToFailure.bind(_this);
    _this.switchTofailureAfterIteration = _this.switchTofailureAfterIteration.bind(_this);
    _this.showFailure = _this.showFailure.bind(_this);
    _this.switchToWorking = _this.switchToWorking.bind(_this);
    _this.fadeOut = _this.fadeOut.bind(_this);
    _this.addAnimationListener = _this.addAnimationListener.bind(_this);
    _this.removeAnimationListener = _this.removeAnimationListener.bind(_this);
    return _this;
  }
  _inherits(LoadingIndicator, _Component);
  return _createClass(LoadingIndicator, [{
    key: "addAnimationListener",
    value: function addAnimationListener(callback) {
      this.element.addEventListener('animationiteration', callback);
    }
  }, {
    key: "removeAnimationListener",
    value: function removeAnimationListener(callback) {
      this.element.removeEventListener('animationiteration', callback, false);
    }
  }, {
    key: "startWorking",
    value: function startWorking() {
      this.setState({
        working: true,
        fast: false
      });
    }
  }, {
    key: "stopAfterIteration",
    value: function stopAfterIteration() {
      this.setState({
        working: false,
        failure: false,
        fade: false,
        fast: false
      });
      this.removeAnimationListener(this.stopAfterIteration);
    }
  }, {
    key: "stopWorking",
    value: function stopWorking() {
      this.addAnimationListener(this.stopAfterIteration);
    }
  }, {
    key: "switchTofailureAfterIteration",
    value: function switchTofailureAfterIteration() {
      this.setState({
        failure: true
      });
      this.removeAnimationListener(this.switchTofailureAfterIteration);
    }
  }, {
    key: "switchToFailure",
    value: function switchToFailure() {
      this.addAnimationListener(this.switchTofailureAfterIteration);
    }
  }, {
    key: "showFailure",
    value: function showFailure() {
      var _this2 = this;
      this.setState({
        fade: true,
        failure: false,
        working: false,
        fast: false
      });
      setTimeout(function () {
        _this2.setState({
          fast: true
        });
        setTimeout(function () {
          _this2.setState({
            fade: false,
            failure: true
          });
        }, timeToSlideToCenter);
      }, timeToFade);
    }
  }, {
    key: "switchToWorking",
    value: function switchToWorking() {
      var _this3 = this;
      this.setState({
        working: false,
        fade: false,
        fast: true
      });
      setTimeout(function () {
        _this3.setState({
          fade: true
        });
        setTimeout(function () {
          _this3.setState({
            working: true,
            failure: false,
            fade: false,
            fast: false
          });
        }, timeToFade);
      }, 0);
    }
  }, {
    key: "fadeOut",
    value: function fadeOut() {
      var _this4 = this;
      this.setState({
        fade: true,
        working: false,
        fast: true
      });
      setTimeout(function () {
        _this4.setState({
          working: false,
          failure: false,
          fade: false,
          fast: false
        });
      }, timeToFade);
    }

    // eslint-disable-next-line camelcase, complexity
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.state.failure && nextProps.error) {
        if (this.state.working) {
          this.switchToFailure();
        } else {
          this.showFailure();
        }
      } else if (this.state.failure && !nextProps.error) {
        if (nextProps.active) {
          this.switchToWorking();
        } else {
          this.fadeOut();
        }
      } else if (!this.state.working && nextProps.active) {
        if (!this.state.failure) {
          this.startWorking();
        }
      } else if (this.state.working && !nextProps.active) {
        if (this.state.failure) {
          this.setState({
            working: false
          });
        } else {
          this.stopWorking();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "aria-hidden": "true",
        className: (0, _classnames["default"])('fixed sb-loadingIndicator', {
          hidden: !this.state.working
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('relative', {
          'sb-loadingIndicatorStatus--fast': this.state.fast,
          'sb-loadingIndicatorStatus--slow': !this.state.fast,
          'sb-loadingIndicatorStatus--working': this.state.working,
          'sb-loadingIndicatorStatus--failure': this.state.failure,
          'sb-loadingIndicatorStatus--fade': this.state.fade
        }),
        ref: function ref(el) {
          return _this5.element = el;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'relative sb-loadingIndicator-stripe'
      })));
    }
  }]);
}(_react.Component);
LoadingIndicator.displayName = 'LoadingIndicator';
LoadingIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A flag indicating that the loading indicator is active and should be displayed.
   */
  active: _propTypes["default"].bool.isRequired,
  /**
   * A flag indicating there is an error is currently being displayed to the user.
   */
  error: _propTypes["default"].bool.isRequired
} : {};
LoadingIndicator.defaultProps = {
  active: false,
  error: false
};
var _default = exports["default"] = LoadingIndicator;